module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cotBj"))).then(() => parcelRequire('d0iPb'));